import { create } from "zustand";
import { executeLogin } from "../helper/Api";
import { LoginRequest, User } from "../types/User";
import Cookies from "js-cookie";

interface UserStore {
   user: User | null;
  //user: LoginRequest | null;
  isAuthenticated: boolean;
  token: string | null;
  login: (user: LoginRequest,  showToast: (message: string, severity: "info" | "success" | "error" | "warning") => void) => Promise<void>;
  logout: () => void;
}

const useUserStore = create<UserStore>((set) => {
  const storedToken = Cookies.get("token");
  const storedUser = storedToken ? JSON.parse(Cookies.get("user") || "{}") : null;
  const isAuthenticated = !!storedToken;

  return {
    user: storedUser,
    isAuthenticated,
    token: storedToken || null,

    login: async (loginRequest, showToast) => {
      try {
        const result = await executeLogin<{ username: string; password: string }>(
          "User/Login",
          loginRequest
        );
          const { token, user: userRq } = result;
          //const { username } = loginRequest;

          Cookies.set("user", JSON.stringify(userRq), { expires: 2 / 24 });
          Cookies.set("token", token, { expires: 2 / 24 });
          // Cookies.set("user", JSON.stringify(username), { expires: 2 / 24 });
          // Cookies.set("token", username, { expires: 2 / 24 });
          set({ user: userRq, isAuthenticated: true, token: token });
       
      } catch (error) {
        console.error("Login error: ", error);
        showToast("An unexpected error occurred during login.", "error");
        throw error;
      }
    },

    logout: () => {
      Cookies.remove("user");
      Cookies.remove("token");

      set({ user: null, isAuthenticated: false, token: null });
    },
  };
});

export default useUserStore;
